import { Ref, RefObject, useImperativeHandle } from 'react';

import { SlotRef } from './types';

interface EnrollSlotRefParams {
  ref: Ref<SlotRef>;
  inputs: SlotRef['inputs'];
  wrapperRef?: RefObject<HTMLDivElement | null>;
}
export const useEnrollSlotRef = ({ ref, inputs }: EnrollSlotRefParams) => {
  useImperativeHandle(ref, () => ({ inputs }), [inputs]);
};
